import React from 'react';
import { useHistory } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';

import { ApiServiceServerless, forceAuthRefresh } from '../../xhr_libs';
import OrganizationBuildingTable from './OrganizationBuildingTable';
import ConfirmationModal, {
  useConfirm,
} from '../../components/modals/ConfirmationModal';
import ResourceDetails from '../../components/ResourceDetails';

import OrganizationTypes from '../../helpers/OrganizationTypes';
import Loader from '../../components/Loader';

export default function OrganizationDetails(props) {
  const {
    org_id,
    organization,
    showToast,
    updateAccess,
    deleteAccess,
    buildingCreateAccess,
    buildingUpdateAccess,
    accountCreateAccess,
    setOrganization,
    isLoading,
  } = props;

  const history = useHistory();
  const [confirmationModalProps, withConfirm] = useConfirm();

  const onDeleteClick = () => {
    let msg = `Are you sure you want to delete the Organization "${organization.name}"? This cannot be undone.`;

    const has_provider_account = organization['has_provider_account'];
    if (has_provider_account) {
      msg +=
        ' Additionally, any Automated Billing accounts assoicatied with this organization will be disabled';
    }

    const beginOrganizationDelete = () => {
      if (has_provider_account) {
        disableProviderAccounts();
      } else {
        deleteOrganization();
      }
    };
    withConfirm(msg, beginOrganizationDelete);
  };

  const disableProviderAccounts = () => {
    ApiServiceServerless.post(
      `/providers/disable/organization/${org_id}`,
      {},
      { authorization_id: org_id }
    )
      .then(() => {
        deleteOrganization();
      })
      .catch((error) => {
        showToast('danger', 'Error', error);
        return false;
      });

    return true;
  };

  const deleteOrganization = () => {
    return ApiServiceServerless.delete(`/organizations/${org_id}`, {
      authorization_id: org_id,
    })
      .then(() => {
        showToast(
          'success',
          'Success',
          `Organization "${organization.name}" was deleted.`
        );
        history.push('/organizations');
      })
      .catch((error) => {
        showToast('danger', 'Error', error);
        throw error;
      })
      .finally(() => {
        forceAuthRefresh();
      });
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <Row style={{ marginBottom: '2em' }}>
            <Col md={2}>
              <ResourceDetails
                header={'Address'}
                value={organization.address}
                variant={'address'}
              />
            </Col>
            <Col md={2}>
              <ResourceDetails
                header={'Organization Type'}
                value={
                  organization.organization_type
                    ? OrganizationTypes[organization.organization_type]
                    : null
                }
              />
            </Col>
          </Row>

          <OrganizationBuildingTable
            organization={organization}
            updateAccess={updateAccess}
            deleteAccess={deleteAccess}
            buildingCreateAccess={buildingCreateAccess}
            buildingUpdateAccess={buildingUpdateAccess}
            accountCreateAccess={accountCreateAccess}
            setOrganization={setOrganization}
            showToast={showToast}
            onDeleteClick={onDeleteClick}
          />
          <ConfirmationModal {...confirmationModalProps} />
        </>
      )}
    </>
  );
}
